import { supabase, isSupabaseConfigured } from '@/lib/supabase'
import { CONVIVENCIA_CHARTER_VERSION } from '@/constants/cartaConvivencia'

async function requireUserId() {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error('SUPABASE_NOT_CONFIGURED')
  }
  const {
    data: { user },
  } = await supabase.auth.getUser()
  if (!user) throw new Error('NOT_AUTHENTICATED')
  return user.id
}

export async function hasConvivenciaAcceptance(
  version = CONVIVENCIA_CHARTER_VERSION,
) {
  if (!isSupabaseConfigured || !supabase) return false

  const userId = await requireUserId()
  const { data, error } = await supabase
    .from('convivencia_acceptances')
    .select('carta_version')
    .eq('user_id', userId)
    .eq('carta_version', version)
    .maybeSingle()

  if (error) throw error
  return Boolean(data)
}

export async function acceptConvivenciaCharter(version = CONVIVENCIA_CHARTER_VERSION) {
  const userId = await requireUserId()

  const { error } = await supabase.from('convivencia_acceptances').insert({
    user_id: userId,
    carta_version: version,
    user_agent: typeof navigator !== 'undefined' ? navigator.userAgent?.slice(0, 240) : null,
  })

  if (error) {
    if (error.code === '23505') return { data: true, error: null }
    throw error
  }
  return { data: true, error: null }
}
